import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { LoginService } from '../../main/content/login/login.service';
import { TranslateService } from '@ngx-translate/core';

import { locale as traduccionES } from '../../i18n/es';
import { locale as traduccionEN } from '../../i18n/en';

@Injectable()
export class NotificacionesService {
    mensajes = new Mensajes(this.translate);
    constructor(
        public snackBar: MatSnackBar,
        private loginService: LoginService,
        private translate: TranslateService
    ) { }

    mostrarAviso(aviso: string, clase?: string) {
        // Metodo generico, se puede usar desde cualquier lado. Muestra snackbar con el mensaje aviso y le puede añadir clases CSS extra pasadas como string
        // El aviso recibido debe ser una constante que se encuentre en los archivos de traduccion
        this.translate.get(aviso).subscribe(
            data => {
                this.snackBar.open(data, 'x', { duration: 4000, extraClasses: [clase], verticalPosition: 'top' });
            },
            err => {
                console.log(err);
                this.snackBar.open(aviso, 'x', { duration: 4000, extraClasses: [clase], verticalPosition: 'top' });
            }
        );
    }
    errorServidor(errorCode: any, mensajeAdicional?: string) {
        // Se usa este metodo cuando el servidor devuelve un error
        switch (errorCode) {
            case 401:
                this.mostrarAviso(this.mensajes.IdiomaActual.MensajesGenerales.NoAutorizado);
                this.loginService.logout();
                break;

            default:
                mensajeAdicional ? this.mostrarAviso(mensajeAdicional) : this.mostrarAviso(this.mensajes.IdiomaActual.MensajesGenerales.ErrorConexion, 'error');
                break;
        }
    }
}

export class Mensajes {
    // Esta interfaz me permite no importar el traduccion.data en cada componente, es mas sencillo importar esto porque va en el servicio de notificaciones
    traduccion = this.translate.currentLang === 'en' ? traduccionEN : traduccionES;

    public idiomaLocal =
        {
            'MensajesGenerales': {
                'ItemsPorPagina': this.traduccion.data.ITEMSXPAGINA,
                'SesionExpirada': this.traduccion.data.SESIONEXPIRADA,
                'NoAutorizado': this.traduccion.data.NOAUTORIZADO,
                'ErrorConexion': this.traduccion.data.ERRORCONEXION,
                'ErrorDesconocido': this.traduccion.data.ERRORDESCONOCIDO,
                'TipoFotoNoValida': this.traduccion.data.TIPOFOTO,
                'TipoExcelNoValido': this.traduccion.data.TIPOEXCEL
            },
            'Login': {
                'CredencialesInvalidas': this.traduccion.data.LOGIN.CREDENCIALESINVALIDAS
            },
            'FileManager': {
                'ClienteNoEstablecido': this.traduccion.data.FILEMANAGER.CLIENTENOESTABLECIDO,
                'BusquedaSinResultados': this.traduccion.data.FILEMANAGER.SINRESULTADOS,
                'NombreIncorrecto': this.traduccion.data.FILEMANAGER.NOMBREINCORRECTO,
                'InicioCopia': this.traduccion.data.FILEMANAGER.INICIOCOPIA,
                'CopiaEnRaizNoPermitida': this.traduccion.data.FILEMANAGER.COPIAENRAIZNOPERMITIDA,
                'CopiaEnMismaCarpeta': this.traduccion.data.FILEMANAGER.COPIAENMISMACARPETA,
                'BorrarCarpeta': {
                    'Titulo': this.traduccion.data.FILEMANAGER.BORRARCARPETA.TITULO,
                    'Mensaje': this.traduccion.data.FILEMANAGER.BORRARCARPETA.MENSAJE
                },
                'BorrarArchivo': {
                    'Titulo': this.traduccion.data.FILEMANAGER.BORRARARCHIVO.TITULO,
                    'Mensaje': this.traduccion.data.FILEMANAGER.BORRARARCHIVO.MENSAJE
                },
                'ActivoCarpetaNotFound': this.traduccion.data.FILEMANAGER.ACTIVOCARPETANOTFOUND,
                'VersionSubida': this.traduccion.data.FILEMANAGER.SUBIDAVERSION,
                'SubirArchivoExistente': {
                    'Titulo': this.traduccion.data.FILEMANAGER.SUBIRARCHIVOEXISTENTE.TITULO,
                    'Mensaje': this.traduccion.data.FILEMANAGER.SUBIRARCHIVOEXISTENTE.MENSAJE
                }
            },
            'Sociedades': {
                'TituloBorrar': this.traduccion.data.SOCIEDADES.MENSAJES.TITULOBORRAR,
                'MensajeBorrar': this.traduccion.data.SOCIEDADES.MENSAJES.MENSAJEBORRAR,
                'SinSociedades': this.traduccion.data.SOCIEDADES.MENSAJES.SINSOCIEDADES,
                'SociedadBorrado': this.traduccion.data.SOCIEDADES.MENSAJES.SOCIEDADBORRADO,
                'SociedadNOBorrado': this.traduccion.data.SOCIEDADES.MENSAJES.SOCIEDADNOBORRADO,
                'SociedadNOObtenido': this.traduccion.data.SOCIEDADES.MENSAJES.SOCIEDADNOOBTENIDO,
                'SociedadCreado': this.traduccion.data.SOCIEDADES.MENSAJES.SOCIEDADCREADO,
                'SociedadNOCreado': this.traduccion.data.SOCIEDADES.MENSAJES.SOCIEDADNOCREADO,
                'SociedadEditado': this.traduccion.data.SOCIEDADES.MENSAJES.SOCIEDADEDITADO,
                'SociedadNOEditado': this.traduccion.data.SOCIEDADES.MENSAJES.SOCIEDADNOEDITADO,
            },

            'Activos': {
                'TituloBorrar': this.traduccion.data.ACTIVOS.MENSAJES.TITULOBORRAR,
                'MensajeBorrar': this.traduccion.data.ACTIVOS.MENSAJES.MENSAJEBORRAR,
                'SinActivos': this.traduccion.data.ACTIVOS.MENSAJES.SINACTIVOS,
                'ActivoBorrado': this.traduccion.data.ACTIVOS.MENSAJES.ACTIVOBORRADO,
                'ActivoNOBorrado': this.traduccion.data.ACTIVOS.MENSAJES.ACTIVONOBORRADO,
                'ActivoNOObtenido': this.traduccion.data.ACTIVOS.MENSAJES.ACTIVONOOBTENIDO,
                'ActivoCreado': this.traduccion.data.ACTIVOS.MENSAJES.ACTIVOCREADO,
                'ActivoNOCreado': this.traduccion.data.ACTIVOS.MENSAJES.ACTIVONOCREADO,
                'ActivoEditado': this.traduccion.data.ACTIVOS.MENSAJES.ACTIVOEDITADO,
                'ActivoNOEditado': this.traduccion.data.ACTIVOS.MENSAJES.ACTIVONOEDITADO,
                'FotoGrande': this.traduccion.data.ACTIVOS.MENSAJES.FOTOGRANDE,
                'Kpis': {
                    'TituloBorrar': this.traduccion.data.ACTIVOS.MENSAJES.KPIS.TITULOBORRAR,
                    'MensajeBorrar': this.traduccion.data.ACTIVOS.MENSAJES.KPIS.MENSAJEBORRAR,
                    'KpiBorrado': this.traduccion.data.ACTIVOS.MENSAJES.KPIS.KPIBORRADO,
                    'KpiNOBorrado': this.traduccion.data.ACTIVOS.MENSAJES.KPIS.KPINOBORRADO,
                },
                'Sectores': {
                    'NOObtenidos': this.traduccion.data.ACTIVOS.MENSAJES.SECTORES.NOOBTENIDOS,
                },
                'Sociedades': {
                    'NOObtenidos': this.traduccion.data.ACTIVOS.MENSAJES.SOCIEDADES.NOOBTENIDOS,
                },
                'Tipologias': {
                    'NOObtenidas': this.traduccion.data.ACTIVOS.MENSAJES.TIPOLOGIAS.NOOBTENIDAS,
                },
                'EstadosProyecto': {
                    'NOObtenidos': this.traduccion.data.ACTIVOS.MENSAJES.ESTADOSPROYECTO.NOOBTENIDOS,
                },
                'Clientes': {
                    'NOObtenidos': this.traduccion.data.ACTIVOS.MENSAJES.CLIENTES.NOOBTENIDOS,
                },
                'PowerBi': {
                    'TituloBorrar': this.traduccion.data.ACTIVOS.MENSAJES.POWERBI.TITULOBORRAR,
                    'MensajeBorrar': this.traduccion.data.ACTIVOS.MENSAJES.POWERBI.MENSAJEBORRAR,
                    'Borrado': this.traduccion.data.ACTIVOS.MENSAJES.POWERBI.BORRADO,
                    'NOBorrado': this.traduccion.data.ACTIVOS.MENSAJES.POWERBI.NOBORRADO,
                    'NOEncontrado': this.traduccion.data.ACTIVOS.MENSAJES.POWERBI.NOENCONTRADO,
                },
                '3DViewer': {
                    'NoEnlace': this.traduccion.data.ACTIVOS.MENSAJES["3DVIEWER"].NOENLACE
                },
                'EnlaceBuilt': {
                    'NoEnlace': this.traduccion.data.ACTIVOS.MENSAJES["MODELBUILT"].NOENLACE
                },
                'CargaExcel': {
                    'ActivosCargados': this.traduccion.data.ACTIVOS.MENSAJES.CARGAEXCEL.OKSUBIDO,
                    'ActivosNoCargados': this.traduccion.data.ACTIVOS.MENSAJES.CARGAEXCEL.ERRORSUBIDA,
                }
            },
            'Clientes': {
                'TituloBorrar': this.traduccion.data.CLIENTES.MENSAJES.TITULOBORRAR,
                'MensajeBorrar': this.traduccion.data.CLIENTES.MENSAJES.MENSAJEBORRAR,
                'SinClientes': this.traduccion.data.CLIENTES.MENSAJES.SINCLIENTES,
                'ClienteBorrado': this.traduccion.data.CLIENTES.MENSAJES.CLIENTEBORRADO,
                'ClienteNOBorrado': this.traduccion.data.CLIENTES.MENSAJES.CLIENTENOBORRADO,
                'ClienteNOObtenido': this.traduccion.data.CLIENTES.MENSAJES.CLIENTENOOBTENIDO,
                'ClienteCreado': this.traduccion.data.CLIENTES.MENSAJES.CLIENTECREADO,
                'ClienteNOCreado': this.traduccion.data.CLIENTES.MENSAJES.CLIENTENOCREADO,
                'ClienteEditado': this.traduccion.data.CLIENTES.MENSAJES.CLIENTEEDITADO,
                'ClienteNOEditado': this.traduccion.data.CLIENTES.MENSAJES.CLIENTENOEDITADO,
            },
            'Tickets': {
                'TituloBorrar': this.traduccion.data.TICKETS.MENSAJES.TITULOBORRAR,
                'MensajeBorrar': this.traduccion.data.TICKETS.MENSAJES.MENSAJEBORRAR,
                'SinTicketsDeActivo': this.traduccion.data.TICKETS.MENSAJES.SINTICKETSDEACTIVO,
                'SinTickets': this.traduccion.data.TICKETS.MENSAJES.SINTICKETS,
                'TicketBorrado': this.traduccion.data.TICKETS.MENSAJES.TICKETBORRADO,
                'TicketNOBorrado': this.traduccion.data.TICKETS.MENSAJES.TICKETNOBORRADO,
                'TicketNOObtenido': this.traduccion.data.TICKETS.MENSAJES.TICKETNOOBTENIDO,
                'TicketCreado': this.traduccion.data.TICKETS.MENSAJES.TICKETCREADO,
                'TicketNOCreado': this.traduccion.data.TICKETS.MENSAJES.TICKETNOCREADO,
                'TicketEditado': this.traduccion.data.TICKETS.MENSAJES.TICKETEDITADO,
                'TicketNOEditado': this.traduccion.data.TICKETS.MENSAJES.TICKETNOEDITADO,
                'SinDocumento': this.traduccion.data.TICKETS.MENSAJES.SINDOCUMENTO,
                'ElegirDocumento': this.traduccion.data.TICKETS.MENSAJES.ELEGIRDOCUMENTO,
                'Usuarios': {
                    'SinUsuarios': this.traduccion.data.TICKETS.MENSAJES.USUARIOS.SINUSUARIOS,
                },
                'Activos': {
                    'SinActivos': this.traduccion.data.TICKETS.MENSAJES.ACTIVOS.SINACTIVOS,
                },
                'NoPuedeVerAnexo': this.traduccion.data.TICKETS.MENSAJES.NOPUEDEVERANEXO,
                'AnexoAdded': this.traduccion.data.TICKETS.MENSAJES.ANEXOADDED
            },
            'Usuarios': {
                'TituloBorrar': this.traduccion.data.USUARIOS.MENSAJES.TITULOBORRAR,
                'MensajeBorrar': this.traduccion.data.USUARIOS.MENSAJES.MENSAJEBORRAR,
                'SinUsuarios': this.traduccion.data.USUARIOS.MENSAJES.SINUSUARIOS,
                'UsuarioBorrado': this.traduccion.data.USUARIOS.MENSAJES.USUARIOBORRADO,
                'UsuarioNOBorrado': this.traduccion.data.USUARIOS.MENSAJES.USUARIONOBORRADO,
                'UsuarioNOObtenido': this.traduccion.data.USUARIOS.MENSAJES.USUARIONOBORRADO,
                'UsuarioCreado': this.traduccion.data.USUARIOS.MENSAJES.USUARIOCREADO,
                'UsuarioNOCreado': this.traduccion.data.USUARIOS.MENSAJES.USUARIONOCREADO,
                'UsuarioEditado': this.traduccion.data.USUARIOS.MENSAJES.USUARIOEDITADO,
                'UsuarioNOEditado': this.traduccion.data.USUARIOS.MENSAJES.USUARIONOEDITADO,
                'Roles': {
                    'SinRoles': this.traduccion.data.USUARIOS.MENSAJES.ROLES.SINROLES,
                },
                'Clientes': {
                    'NOObtenidos': this.traduccion.data.USUARIOS.MENSAJES.CLIENTES.NOOBTENIDOS,
                },
                'ActivosOcultos': {
                    'SinActivos': this.traduccion.data.USUARIOS.MENSAJES.ACTIVOSOCULTOS.SINACTIVOS
                },
            },
            'Perfil': {
                'PassCambiada': this.traduccion.data.MYPROFILE.MENSAJES.PASSACTUALIZADA,
                'PassIgual': this.traduccion.data.MYPROFILE.MENSAJES.PASSIGUAL,
                'PassReseteada': this.traduccion.data.MYPROFILE.MENSAJES.PASSRESETEADA,
                'PassNoReseteada': this.traduccion.data.MYPROFILE.MENSAJES.PASSNORESETEADA,
                'FormularioEnviado': this.traduccion.data.MYPROFILE.MENSAJES.FORMULARIOENVIADO,
                'FormularioNoEnviado': this.traduccion.data.MYPROFILE.MENSAJES.FORMULARIONOENVIADO
            },
            'Dashboard': {
                'Reporting': this.traduccion.data.DASHBOARD.STATS.REPORTING,
                'Built': this.traduccion.data.DASHBOARD.STATS.BUILT,
            }
        };
    public IdiomaActual = { ...this.idiomaLocal };

    constructor(private translate) {
        this.IdiomaActual = { ...this.idiomaLocal };
    }

}



// WEBPACK FOOTER //
// ./src/app/core/notificaciones/notificaciones.service.ts